export const features = {
  order: {},
  payment: {
    noteField: 900,
  },
};
